import { Checkbox } from "@chakra-ui/checkbox";
import { Flex } from "@chakra-ui/layout";
import { useState, useEffect } from "react";

function useSelectableColumn<T extends { id: string }>(
  fullData?: T[],
  onSelected?: (items: T[]) => void,
  defaultSelected: T[] = []
) {
  const [selected, setSelected] = useState<T[]>(defaultSelected);

  useEffect(() => {
    if (typeof onSelected === "function") {
      onSelected(selected);
    }
  }, [onSelected, selected]);

  const isAllSelected = selected.length === fullData?.length;

  const handleSelect = (e: T) => {
    setSelected((prevSelected) => [...prevSelected, e]);
  };

  const handleUnselect = (e: T) => {
    setSelected((state) => state.filter((s) => s.id !== e.id));
  };

  const handleSelectAll = () => {
    fullData && setSelected(fullData);
  };
  const handleUnselectAll = () => {
    setSelected([]);
  };

  return {
    selected,
    column: {
      disableSortBy: true,
      Header: () =>
        fullData?.length ? (
          <Checkbox
            isChecked={isAllSelected}
            isIndeterminate={
              !!(selected.length && selected.length !== fullData.length)
            }
            onChange={() =>
              !isAllSelected ? handleSelectAll() : handleUnselectAll()
            }
          />
        ) : null,
      accessor: "id",
      width: 50,
      disableClick: true,
      Cell: ({ row: { original } }: { row: { original: T } }) => {
        const isCheck = !!selected.find((s) => s.id === original.id);

        return (
          <Flex alignItems="center">
            <Checkbox
              isChecked={isCheck}
              onChange={() =>
                !isCheck ? handleSelect(original) : handleUnselect(original)
              }
            />
          </Flex>
        );
      },
    },
  };
}

export default useSelectableColumn;
